'use client';

import { c as _c } from "react/compiler-runtime";
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@sola/ark-core/atoms/badge/badge.tsx';
import { RadioGroupButtons, RadioGroupButtonsItem } from '@sola/ark-core/molecules/radio-group-buttons/radio-group-buttons.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { PaymentMethodTypesEnum } from '@sola/schema/dotcom/supporters/paymentMethods.ts';
import { IconNames } from '@sola/schema/lib/icons/icon-names.ts';
interface PaymentMethodSwitchProps {
  setSelectedPaymentMethod: Dispatch<SetStateAction<PaymentMethodTypesEnum>>;
}
type PaymentMethodButtonProps = {
  value: PaymentMethodTypesEnum;
  iconName: IconNames;
  labelKey: string;
  isPreferred?: boolean;
};
const buttons: PaymentMethodButtonProps[] = [{
  value: PaymentMethodTypesEnum.Ach,
  iconName: 'bank',
  labelKey: 'payments.methodTypes.ach.short',
  isPreferred: true
}, {
  value: PaymentMethodTypesEnum.Card,
  iconName: 'credit-card-02',
  labelKey: 'payments.methodTypes.creditCard.short'
}];
export const PaymentMethodSwitch = t0 => {
  const $ = _c(5);
  const {
    setSelectedPaymentMethod
  } = t0;
  const {
    t
  } = useTranslation("my");
  let t1;
  if ($[0] !== t) {
    t1 = buttons.map(button => <RadioGroupButtonsItem value={button.value} id={button.value} key={button.value}><div className="flex flex-col gap-snug-md"><ArkIcon iconName={button.iconName} width="1.5rem" height="1.5rem" /><div className="flex gap-snug-lg items-center"><span className="label-md label-potent">{t(button.labelKey)}</span>{button.isPreferred && <Badge color="positive" label={t("addPaymentMethod.switchLabels.preferred")} size="sm" />}</div></div></RadioGroupButtonsItem>);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setSelectedPaymentMethod || $[3] !== t1) {
    t2 = <div><RadioGroupButtons defaultValue={PaymentMethodTypesEnum.Ach} onChange={setSelectedPaymentMethod}>{t1}</RadioGroupButtons></div>;
    $[2] = setSelectedPaymentMethod;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};